module.exports = __webpack_public_path__ + "img/loading.0a000667.gif";